module.exports = __webpack_public_path__ + "static/media/成功@3x.a3f01.png";